import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Integration } from "../integration";

@Component({
  selector: 'app-oauth2-button',
  templateUrl: './oauth2-button.component.html',
  styleUrls: ['./oauth2-button.component.scss']
})
export class Oauth2ButtonComponent implements OnInit, AfterViewInit {
  /** Component inputs */
  @Input () public readonly integration: Integration;

  /**
   * OAuth 2.0 connection state.
   * 
   * * `connected` represents the state when the connection is established.
   * * `disconnected` is the state when the OAuth 2.0 connection is not established.
   * * `relaying` is when the the authorization code is being relayed to the backend.
   * * `error` is when something's gone wrong with the whole OAuth flow.
   */
  private _state: 'connected' | 'disconnected' | 'relaying' | 'error';

  /** A registered OAuth 2.0 client ID. */
  get clientId(): string  { return this.integration.oauth.client_id; }

  /** Authorization server endpoint */
  get issuer(): string  { return this.integration.oauth.issuer; }

  /** A registered OAuth 2.0 redirect URI. */  
  get redirectUri() : string  { return this.integration.oauth.redirect_uri; }

  /** OAuth 2.0 response type. */
  get responseType(): string  { return this.integration.oauth.response_type; }

  /** Connection scope. */
  get scope(): string  { return this.integration.oauth.scope; }

  /** Whether a OAuth 2.0 connection is established. */
  get isConnected(): boolean { return this.integration.connection.is_connected; }

  public constructor(
    private client: HttpClient,
    private route : ActivatedRoute,
    private toast : ToastrService
  ) { }

  public ngOnInit() {
    this._state = this.integration.connection.is_connected? 'connected' : 'disconnected';

    this.route.queryParams.subscribe({
      next: (params) => {
        if(params.code) {
          this._state = 'relaying';
        }
      },
      error: () => this._state = 'error'
    });
  }

  public ngAfterViewInit() { }

  /**
   * Terminate OAuth connection.
   */
  public disconnect() {
    this.client
      .delete(this.integration.oauth.disconnect_uri)
      .subscribe({
        next: () => {
          this.integration.connection.is_connected = false;
          this.toast.success(null, `You're now disconnected from ${this.integration.name}`);
        },
        error: () => {
          this._state = 'error';
        }
      });
  }
}
